module.exports = __webpack_public_path__ + "static/esi-logo-149690018275ca93f2c257cb9a8511c0.png";